import { useQuery } from "@tanstack/react-query"

import { getWhatsNewApi } from "@/api/api"
import { queryKeys } from "@/lib/query-keys"
import { SettingsService } from "@/services/settings-service"

const ONE_HOUR_MS = 60 * 60 * 1000
const TWO_HOURS_MS = 2 * 60 * 60 * 1000

/**
 * Fetches What's New content for a locale.
 *
 * When `previewVersion` is set, the backend serves that exact version (admin
 * preview); the query is keyed separately so a preview doesn't poison the
 * default-mode cache and is not retained across mounts.
 */
export function useWhatsNew(locale: string, previewVersion?: string) {
  const { token } = SettingsService.getInstance()
  const isPreview = Boolean(previewVersion)

  return useQuery({
    queryKey: queryKeys.whatsNew(locale, previewVersion),
    queryFn: () => getWhatsNewApi(locale, token, previewVersion),
    staleTime: isPreview ? 0 : ONE_HOUR_MS,
    gcTime: isPreview ? 0 : TWO_HOURS_MS,
    refetchOnWindowFocus: false,
    refetchOnMount: isPreview,
    refetchOnReconnect: false,
  })
}
